import React from 'react';

function Divider() {
  return <li className="divider" />;
}

export default Divider;
